// extracted by mini-css-extract-plugin
module.exports = {"media-library":"media-library_media-library__29xeL","inspector-tabs":"media-library_inspector-tabs__3w2se","is-sidebar-active":"media-library_is-sidebar-active__2dUBY"};